import type { DriveStep } from 'driver.js';

export const attorneyIntakeSteps: DriveStep[] = [
  {
    element: '[data-tour="attorney-intake-header"]',
    popover: {
      title: 'Client Submissions',
      description: 'Requests submitted by clients through your custom intake form link.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="attorney-intake-search"]',
    popover: {
      title: 'Search and Filter',
      description: 'Find submissions by name, email, or case type. Filter by status.',
      side: 'bottom',
      align: 'center',
    },
  },
  {
    element: '[data-tour="attorney-intake-list"]',
    popover: {
      title: 'Review and Act',
      description:
        'Click a request to view details. Accept to create a case, or reject with an explanation.',
      side: 'top',
      align: 'center',
    },
  },
];
